import { User } from 'firebase/auth';
import { ShieldCheck, UserRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const AccountDetails = ({ user }: { user: User }) => {
  const { t } = useTranslation();
  const methods = user.providerData.map(({ providerId }) => {
    switch (providerId) {
      case 'password':
        return t('redemption_page.email_password');
      case 'google.com':
        return t('redemption_page.google');
      case 'facebook.com':
        return t('redemption_page.facebook');
      case 'apple.com':
        return t('redemption_page.apple');
      default:
        return t('redemption_page.original_method');
    }
  });

  return (
    <div className="redemption-account">
      <span className="redemption-avatar">
        <UserRound size={22} aria-hidden="true" />
      </span>
      <div>
        <p className="sr-only">{t('redemption_page.account_label')}</p>
        <strong>{user.email || user.displayName || t('redemption_page.selected_account')}</strong>
        <p>
          {t('redemption_page.sign_in_method', {
            methods: methods.join(', ') || t('redemption_page.original_method'),
          })}
        </p>
        {user.providerData.some(({ providerId }) => providerId === 'apple.com') && (
          <p>{t('auth_page.apple_ios_note')}</p>
        )}
      </div>
      <ShieldCheck className="redemption-account-check" size={20} aria-hidden="true" />
    </div>
  );
};
